export default "__VITE_ASSET__CyAPp9pi__"